import { render, staticRenderFns } from "./ls-change-component.vue?vue&type=template&id=3f6a026c"
import script from "./ls-change-component.vue?vue&type=script&lang=js"
export * from "./ls-change-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports